module.exports = __webpack_public_path__ + "static/media/arcade-dark-background.dcf848fb.png";